/** ธีมชั่วคราวจาก backup_old_version/huay_scratch-lottery-theme */

export type ScratchThemeId = 'gold' | 'sky' | 'crimson' | 'violet' | 'lime'

export type ScratchThemeDef = {
  id: ScratchThemeId
  label: string
  accent: string
  bg: string
  header: string
  starWin: string
  starPlay: string
}

const THEMES: Record<ScratchThemeId, ScratchThemeDef> = {
  gold: {
    id: 'gold',
    label: 'ทอง',
    accent: '#fdb929',
    bg: '/scratch-lottery-theme/bg1.png',
    header: '/scratch-lottery-theme/h1.png',
    starWin: '/scratch-lottery-theme/star1.png',
    starPlay: '/scratch-lottery-theme/star2.png',
  },
  sky: {
    id: 'sky',
    label: 'ฟ้า',
    accent: '#3cc5fb',
    bg: '/scratch-lottery-theme/bg2.png',
    header: '/scratch-lottery-theme/h2.png',
    starWin: '/scratch-lottery-theme/star3.png',
    starPlay: '/scratch-lottery-theme/star3.png',
  },
  crimson: {
    id: 'crimson',
    label: 'แดง',
    accent: '#e22425',
    bg: '/scratch-lottery-theme/bg3.png',
    header: '/scratch-lottery-theme/h3.png',
    starWin: '/scratch-lottery-theme/star2.png',
    starPlay: '/scratch-lottery-theme/star2.png',
  },
  violet: {
    id: 'violet',
    label: 'ม่วง',
    accent: '#9b438c',
    bg: '/scratch-lottery-theme/bg4.png',
    header: '/scratch-lottery-theme/h4.png',
    starWin: '/scratch-lottery-theme/star3.png',
    starPlay: '/scratch-lottery-theme/star3.png',
  },
  lime: {
    id: 'lime',
    label: 'เขียว',
    accent: '#a3c84b',
    bg: '/scratch-lottery-theme/bg5.png',
    header: '/scratch-lottery-theme/h5.png',
    starWin: '/scratch-lottery-theme/jp.png',
    starPlay: '/scratch-lottery-theme/jp.png',
  },
}

const ALIASES: Record<string, ScratchThemeId> = {
  america: 'gold',
  classic: 'crimson',
  neon: 'violet',
  thai: 'lime',
  gold: 'gold',
  sky: 'sky',
  crimson: 'crimson',
  violet: 'violet',
  lime: 'lime',
}

export function resolveScratchTheme(raw?: string | null): ScratchThemeDef {
  const key = String(raw || '').trim().toLowerCase()
  const id = ALIASES[key] || 'gold'
  return THEMES[id]
}
